import {
	type ITrackingActions,
	TRACKING_ACTIONS,
	TRACKING_CATEGORIES,
	TRACKING_EVENTS,
} from '~/services/actions/tracking-actions';

export const handleEvent = (
	label: string,
	trackingActions: ITrackingActions,
): void => {
	if (label) {
		trackingActions.eventTracking({
			event: TRACKING_EVENTS.BOTTOM_NAVIGATION,
			eventCategory: TRACKING_CATEGORIES.NAVIGATION,
			eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BOTTOM_NAVIGATION],
			eventLabel: label,
		});
	}
};
